import { Link } from "react-router-dom";
import { useState } from "react";
import { useStore } from "../context/StoreContext";
import ProductCard from "../components/ProductCard";
import QuickView from "../components/QuickView";
import { FadeUp, RevealMaskScroll } from "../components/Reveal";
import { ArrowRight } from "lucide-react";

export default function Wishlist() {
  const { wishlist } = useStore();
  const [quickView, setQuickView] = useState(null);
  const [qvOpen, setQvOpen] = useState(false);
  const openQuickView = (p) => { setQuickView(p); setQvOpen(true); };

  return (
    <div className="pt-20" data-testid="wishlist-page">
      <div className="px-5 md:px-10 pt-16 pb-10 max-w-[1600px] mx-auto">
        <FadeUp><p className="overline text-gold-deep mb-4">Saved</p></FadeUp>
        <h1 className="font-serif text-6xl md:text-8xl tracking-tight leading-none">
          <RevealMaskScroll>Wishlist</RevealMaskScroll>
        </h1>
      </div>

      {wishlist.length === 0 ? (
        <div className="py-32 text-center px-6">
          <p className="font-serif text-3xl mb-4">No favourites yet</p>
          <p className="text-ink-soft mb-8">Tap the heart on any piece to keep it here.</p>
          <Link to="/shop" className="btn-ink inline-flex items-center gap-2 px-10 py-4 overline">Discover pieces <ArrowRight size={14} /></Link>
        </div>
      ) : (
        <div className="px-5 md:px-10 max-w-[1600px] mx-auto grid grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-12 md:gap-x-6 pb-28">
          {wishlist.map((p, i) => (
            <ProductCard key={p.slug} product={p} index={i} onQuickView={openQuickView} />
          ))}
        </div>
      )}
      <QuickView product={quickView} open={qvOpen} onOpenChange={setQvOpen} />
    </div>
  );
}
